import AOSInitializer from "./AOSInitializer";
import Routes from "./Routes";
function App() {
  return (
    <div>
      <AOSInitializer>
        <Routes />
      </AOSInitializer>
    </div>
  );
}

export default App;
